import React from 'react';
import { createRoot } from 'react-dom/client';
import AccordionSearch from './react/AccordionSearch';

const getItemsFromScript = async ($script) => {
  if (!$script) {
    console.warn('accordion-search__data script tag not found');
    return [];
  }

  const json = await JSON.parse($script.textContent);

  if (!json || json.length === 0) {
    console.error('No data found in accordion-search__data');
    return [];
  }

  return json;
};

const initAccordionSearch = async ($el) => {
  const $wrap = document.createElement('div');
  $wrap.classList.add('accordion-search__wrap');
  $el.appendChild($wrap);
  const $script = $el.querySelector('.accordion-search__data');
  const $alert = $el.querySelector('.accordion-search__alert');
  const data = (await getItemsFromScript($script)) || [];
  const root = createRoot($wrap);
  root.render(<AccordionSearch {...data} />);
  $script?.remove();
  $alert?.remove();
};

document
  .querySelectorAll('.accordion-search')
  .forEach(($tax) => initAccordionSearch($tax));
